import React, { useContext, useMemo } from 'react'
import { Grid } from '@mui/material'
import PrimeTable from '../../../components/PrimeTable'
import { barraVoltar, PontoDeVendaContext } from '.'
import { metodoPrograma } from '../../../components/api'

export const STATUS_MAP = {
  0: { label: 'Em Preparação', color: '#1976d2', background: '#e3f2fd' },
  1: { label: 'Pronto para Cobrar', color: '#ff9800', background: '#fff3e0' },
  2: { label: 'Cobrado', color: '#2e7d32', background: '#e8f5e9' },
  9: { label: 'Cancelado', color: '#9e9e9e', background: '#ffebee' },
}

export function StatusChip({ status, label, background, color, style }) {
  const info = !label ? STATUS_MAP[status] : { label, background, color }

  if (!info) return status // fallback

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        color: info.color,
        backgroundColor: info.background,
        ...style,
      }}
    >
      {info.label}
    </span>
  )
}

const ListaPontoVenda = () => {
  const { idPontoVenda, dispatch, cadastroVenda, reload } =
    useContext(PontoDeVendaContext)

  const parametrosTabela = useMemo(() => ({ idPontoVenda }), [idPontoVenda])

  const head = [
    '#',
    'Vendedor',
    'Paciente',
    'Forma Pagamento',
    'Data',
    'Situação',
    'Total',
  ]

  const line = (item) => [
    item?.[0],
    item?.[2][1] || '',
    item?.[5]?.[1] || '',
    '',
    item?.[14],
    item[9] ? <StatusChip status={item[9]} /> : '',
    item?.[18],
  ]

  // const criaIdxListaProdutos = (lista = []) => lista.map()

  const seleiconaLinha = async (linha) => {
    const { status, lista } = await metodoPrograma('getItens', {
      idPontoVenda: linha?.[0],
    })
    const formasPagamentoSelecionadas = (linha?.[10] || []).map((item) => [
      [item?.[0]?.[0], crypto.randomUUID()],
      ...item.slice(1),
    ])

    const payload = {
      ...cadastroVenda,
      idPedidoVenda: linha?.[0] || null,
      acCliente: linha?.[5] || [],
      acAtendimento: linha?.[2] || [],
      acFormaPagamento: formasPagamentoSelecionadas,
      listaProduto:
        status && lista?.length
          ? lista.map((v) => ({
              idx: Symbol('idx ' + v?.idProduto),
              ...v,
              vlUnitarioInicial: v?.vlUnitario || 0,
            }))
          : [],
      vlDesconto: linha?.[16] || 0,
      prDesconto: linha?.[17] || 0,
      tpSituacao: linha?.[9] || '0',
      dsObservacoes: linha?.[13] || '',
      snCobraCheckout: linha?.[19] || 'N',
      formasPagamento: formasPagamentoSelecionadas.map((v) => ({
        idFormaPagamento: v?.[0]?.[0],
        vlPago: v?.[2] || 0,
        qtParcelas: v?.[4] || 0,
        isParcelas: v?.[3],
        unic: v?.[0]?.[1],
      })),
    }

    dispatch({ type: 'barraFerramenta', value: barraVoltar })
    dispatch({ type: 'cadastroVenda', value: payload })
    dispatch({ type: 'tela', value: 'venda' })
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PrimeTable
          lineStyle={{ textOverflow: 'ellipsis' }}
          disablePagination
          action="listaPedido"
          codigo="CtrlPontoVenda"
          habSearch={true}
          parametros={parametrosTabela}
          onRowSelect={seleiconaLinha}
          refresh={reload}
          collumnsDateHour={[4]}
          collumnsCurrency={[6]}
          head={head}
          line={line}
          columnOptions={[
            {
              alias: 3,
              customJsx: ({ linhaOriginal }) => (
                <Grid container>
                  {linhaOriginal?.[10]?.map((item) => (
                    <StatusChip
                      key={item[0]?.[0]}
                      color={'#e3f2fd'}
                      background={'#1976d2'}
                      style={{ marginRight: '5px' }}
                      label={item[1].toUpperCase()}
                    />
                  ))}
                </Grid>
              ),
            },
          ]}
        />
      </Grid>
    </Grid>
  )
}

export default ListaPontoVenda
